import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { AutocompleteInput, required, TextInput } from 'react-admin';
import { Field } from 'react-final-form';
import { disableAutofillOptions } from '../../helper';
import useStyles from '../../QuickActions/styles';
import ImageUploadSelector from '../../tabs/ImageUploadSelector';
import {
  heavyDutyEngineMakes,
  heavyDutyFuelTypes,
  heavyDutyMakes,
} from '../../VehicleConstants';
import { validateVIN } from '../../vehicleHelper';
import VINInput from './VINInput';

const HeavyDutyForm = ({
  years,
  handleChange,
  handleHeavyChange,
  vehicle,
  setIsPhotoUploading,
}) => {
  const classes = useStyles();

  return (
    <Box>
      <Grid
        container
        spacing={1}
        className={`${classes.formRoot} ${classes.width100}`}
      >
        <Grid item xs={12} sm={6} md={4}>
          <Field
            label="VIN"
            name="heavy.vin"
            component={VINInput}
            validate={validateVIN}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Year"
            source="heavy.year"
            choices={years}
            onChange={(value) => {
              handleChange('year', value);
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Make"
            source="heavy.make"
            choices={heavyDutyMakes}
            validate={[required()]}
            options={disableAutofillOptions}
            onChange={handleHeavyChange('make')}
          />
          {vehicle?.heavy?.make === 'Other' && (
            <TextInput
              source="custom.heavyMake"
              label="Custom Make"
              validate={[required()]}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextInput source="heavy.model" label="Model" />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Engine Make"
            source="heavy.heavy_duty_engine_make"
            choices={heavyDutyEngineMakes}
            options={disableAutofillOptions}
            onChange={handleHeavyChange('heavy_duty_engine_make')}
          />

          {vehicle?.heavy?.heavy_duty_engine_make === 'Other' && (
            <TextInput
              source="custom.heavyEngineMake"
              label="Custom Engine Make"
              validate={[required()]}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextInput
            source="heavy.heavy_duty_engine_serial_number"
            label="Engine ID"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AutocompleteInput
            label="Fuel Type"
            source="heavy.fuel_type"
            choices={heavyDutyFuelTypes}
            options={disableAutofillOptions}
            onChange={handleHeavyChange('fuel_type')}
          />

          {vehicle?.heavy?.fuel_type === 'Other' && (
            <TextInput
              source="custom.fuelType"
              label="Custom Fuel Type"
              validate={[required()]}
            />
          )}
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        className={`${classes.formRoot} ${classes.width100}`}
      >
        <ImageUploadSelector
          record={{}}
          resource="vehicle"
          source="photo_filenames"
          folder="vehicle"
          setIsUploading={setIsPhotoUploading}
          multiple
          saveAsUrl={false}
        />
      </Grid>
    </Box>
  );
};

export default HeavyDutyForm;
